module.exports = __webpack_public_path__ + "img/content-1.5661c969.png";